export const fields = [
  {
    identifier: 'code',
    label: 'code',
    rules: [{ required: true, message: 'برجاء ملء هذه الخانة' }],
    placeholder: 'code-placeholder',
    type: 'input',
  },
];
